import { AttachedPropertyValue, ComponentView } from "binder";
import { GridViewModel } from "./grid-viewModel"


class Position{
    constructor() {
        this.column=1;
        this.row=1;
        this.columnSpan=1;
        this.rowSpan=1;        
    }
    column:number;
    row:number;
    columnSpan:number;
    rowSpan:number;
}
export class GridView extends ComponentView<GridViewModel>{
    GetViewUniqueId(): string {
        return "V-D7E0E142-E562-4D21-AD09-7FC51317C9F0"
    }
    loadHtml(): string {
        let element = require('./grid.html').default;
        let style = require('./grid.less');
        return element;
    }
    constructor() {
       super();
       this.positions = new WeakMap<Node,Position>();
    }
    private positions:WeakMap<Node,Position>;
    public set columndefinition(v: string) { 
        this._columndefinition = v;
        this.updateGridDefinitions();
    } public get columndefinition(): string { return this._columndefinition;} private _columndefinition: string;
    public set rowdefinition(v: string) { 
        this._rowdefinition = v; 
        this.updateGridDefinitions();
    } public get rowdefinition(): string { return this._rowdefinition;} private _rowdefinition: string;
    
    public set column(v: AttachedPropertyValue) { 
        this._column = v; 
        if(v==null) return;
        this.getElementPosition(v.node).column=parseInt(v.value.toString());
        this.updateNodePosition(v.node);
    } public get column(): AttachedPropertyValue { return this._column;} private _column: AttachedPropertyValue;
    public set row(v: AttachedPropertyValue) { 
        this._row = v;
        if(v==null) return;
        this.getElementPosition(v.node).row=parseInt(v.value.toString());
        this.updateNodePosition(v.node);
    } public get row(): AttachedPropertyValue { return this._row;} private _row: AttachedPropertyValue;
    public set columnspan(v: AttachedPropertyValue) { 
        this._columnspan = v;
        if(v==null) return;
        this.getElementPosition(v.node).columnSpan=parseInt(v.value.toString());
        this.updateNodePosition(v.node);
    } public get columnspan(): AttachedPropertyValue { return this._columnspan;} private _columnspan: AttachedPropertyValue;
    public set rowspan(v: AttachedPropertyValue) {
         this._rowspan = v;
         if(v==null) return;
         this.getElementPosition(v.node).rowSpan=parseInt(v.value.toString());
         this.updateNodePosition(v.node); 
    } public get rowspan(): AttachedPropertyValue { return this._rowspan;} private _rowspan: AttachedPropertyValue;


    private getElementPosition(node:Node):Position{
        if(this.positions.has(node)==false){
            let newPosition = new Position();
            this.positions.set(node,newPosition);
        }
        return this.positions.get(node);
    }

    private updateNodePosition(node:Node){
        let position = this.getElementPosition(node);
        let element = <HTMLElement>node;
        element.style['grid-column-start']=position.column;
        element.style['grid-column-end']= position.column+position.columnSpan;
        element.style['grid-row-start']=position.row;
        element.style['grid-row-end']=position.row+position.rowSpan;
    }
    onRenderCompleted(){
        this.updateGridDefinitions();
    }
    updateGridDefinitions(){
        if(this.firstlevelElement){
            (<HTMLElement>this.firstlevelElement).style['grid-template-columns']=this.columndefinition;
            (<HTMLElement>this.firstlevelElement).style['grid-template-rows']=this.rowdefinition;
        }
    }
}
